import React from 'react';
import { WarningDialog } from '@innovyze/stylovyze';
import { Grid } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';
import { SensorHistoryStoreState } from '@Types';
import {
	HistoricalSeries,
	RawMeasureDatum,
	Readings,
	Resolutions,
	SensorChart,
} from '@innovyze/summaryze';

interface PeekModalProps {
	open: boolean;
	onConfirm: () => void;
	onCancel: () => void;
	data: SensorHistoryStoreState['peek']['response']['data'];
	sensorId: string;
}

const PeekDialog = (props: PeekModalProps) => {
	const { t } = useGlobalization();
	const { sensorId, open, data, onConfirm, onCancel } = props;

	// ? [timestamp (in ms), open, close, low, high, average, sum]
	// @ts-ignore
	const values = data.map<RawMeasureDatum>(el => [
		parseInt(el.ts),
		typeof el.value === 'string' ? parseFloat(el.value) : el.value, // open
		typeof el.value === 'string' ? parseFloat(el.value) : el.value, // close
		typeof el.value === 'string' ? parseFloat(el.value) : el.value, // low
		typeof el.value === 'string' ? parseFloat(el.value) : el.value, // high
		typeof el.value === 'string' ? parseFloat(el.value) : el.value, // average
		typeof el.value === 'string' ? parseFloat(el.value) : el.value, // sum
	]);

	// @ts-ignore
	const chartProps: HistoricalSeries = {
		data: values,
		alias: sensorId,
		displayOptions: {},
		unit: '',
		id: 'id',
		resolution: Resolutions.Raw,
		func: Readings.Close,
	};

	return (
		<WarningDialog
			title={t('Peek data')}
			open={open}
			cancelText={t('Ok')}
			onCancel={onCancel}
			dividers="both">
			<Grid container spacing={4}>
				<div style={{ width: '500px' }}>
					<SensorChart series={chartProps} />
				</div>
			</Grid>
		</WarningDialog>
	);
};

export default PeekDialog;
